import React from "react";

const TermsAndConditions = ({ darkTheme }) => {
  return (
    <div
      id="terms-policy"
      className="modal fade"
      role="dialog"
      aria-hidden="true"
    >
      <div
        className="modal-dialog modal-lg modal-dialog-centered"
        role="document"
      >
        <div
          className={
            "modal-content " + (darkTheme ? "bg-dark-2 text-light" : "")
          }
        >
          <div className="modal-header">
            <h5 className={"modal-title " + (darkTheme ? "text-white" : "")}>
              Conditions G&eacute;n&eacute;rales d'Utilisation
            </h5>
            <button
              type="button"
              className={"btn-close " + (darkTheme ? "btn-close-white" : "")}
              data-bs-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div className="modal-body p-4">
            <p>
              Bienvenue sur le portfolio en ligne d'Osama Khait. En accédant à ce site,
              vous acceptez les présentes conditions générales d'utilisation. Ce site a pour
              vocation de présenter mon parcours, mes compétences et mes réalisations dans
              le domaine du développement web et informatique.
            </p>
            <h3 className={"mb-3 mt-4 " + (darkTheme ? "text-white" : "")}>
              Conditions d'utilisation
            </h3>
            <p>
              Ce site est un portfolio personnel à but non commercial. Tout le contenu
              présenté (textes, images, projets) est la propriété d'Osama Khait, sauf
              mention contraire. Vous êtes autorisé à consulter librement ce site, mais
              toute reproduction ou utilisation du contenu sans autorisation préalable est interdite.
            </p>
            <h5 className={"text-4 mt-4 " + (darkTheme ? "text-white" : "")}>
              Article 1 – Informations collectées
            </h5>
            <p>
              Le formulaire de contact présent sur ce site permet de m'envoyer un message
              par email. Les informations transmises (nom, adresse email, message) sont
              utilisées uniquement pour répondre à votre demande et ne sont ni stockées
              dans une base de données, ni partagées avec des tiers.
            </p>
            <h5 className={"text-4 mt-4 " + (darkTheme ? "text-white" : "")}>
              Article 2 – Propriété intellectuelle
            </h5>
            <p>
              L'ensemble des éléments composant ce site (design, textes, code source,
              logos, images de projets) sont protégés par le droit de la propriété
              intellectuelle. Toute reproduction, même partielle, est soumise à
              autorisation préalable.
            </p>
            <h5 className={"text-4 mt-4 " + (darkTheme ? "text-white" : "")}>
              Article 3 – Responsabilité
            </h5>
            <p>
              Les informations fournies sur ce site sont données à titre indicatif.
              Je m'efforce de maintenir les informations à jour, mais je ne garantis
              pas l'exactitude ou l'exhaustivité du contenu. Je ne saurais être tenu
              responsable de tout dommage résultant de l'utilisation de ce site.
            </p>
            <h3 className={"mb-3 mt-4 " + (darkTheme ? "text-white" : "")}>
              Politique de confidentialité
            </h3>
            <p>
              Ce site respecte votre vie privée. Aucun cookie de suivi ou outil
              d'analyse tiers n'est utilisé. Les seules données traitées sont celles
              que vous transmettez volontairement via le formulaire de contact.
            </p>
            <ol className="lh-lg">
              <li>
                Aucune donnée personnelle n'est collectée automatiquement lors de
                votre navigation sur ce site.
              </li>
              <li>
                Les informations envoyées via le formulaire de contact sont transmises
                directement par email et ne sont pas stockées sur un serveur.
              </li>
              <li>
                Ce site n'utilise pas de cookies de pistage ni d'outils d'analyse
                comportementale.
              </li>
              <li>
                Vous disposez d'un droit d'accès, de rectification et de suppression
                de vos données personnelles conformément au RGPD.
              </li>
              <li>
                Pour toute question relative à vos données, vous pouvez me contacter
                à l'adresse : osama@khait.fr.
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
